const favorites = {
  id: undefined,
  favorite_items: undefined,

  stringRandom(length) {
    const characters = 'abdefil012345679'
    let result = ''
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },

  generateFavoritesUid() {
    if ($('.header__secondary-menu').data('list-id') != 'new') {
      return $('.header__secondary-menu').data('list-id')
    }
    let string = ''
    while (string.length < 32) {
      string += this.stringRandom(Math.floor(Math.random() * (16 - 4 + 1)) + 4)
      string += '-'
    }
    string = string.slice(0, -1)
    if (string.length < 32) {
      string += this.stringRandom(1)
    }
    return string.substring(0, 32).toLowerCase()
  },

  add(content_uid, response) {
    if (!this.favorite_items.includes(content_uid)) {
      this.favorite_items.push(content_uid);
      localStorage.setItem('bookmarks_items', JSON.stringify(this.favorite_items))
    }
  },

  remove(content_uid) {
    this.favorite_items = this.favorite_items.filter(item => item !== content_uid);
    localStorage.setItem('bookmarks_items', JSON.stringify(this.favorite_items))
  },

  has(content_uid) {
    return this.favorite_items.includes(content_uid)
  },

  buttons(scope) {
    if (scope == undefined) {
      scope = document
    }
    $(scope).find('button.favorite__toggle, .btn-bookmark').each(function() {
      $(this).FavoriteButton()
    })
  },

  page() {
    if ($('.page-bookmarks').length) {
      $('.favorites-grid').FavoritesPage()
    }
  },

  init() {
    if ('localStorage' in window) {
      this.id = localStorage.getItem('bookmarks_id')
      this.favorite_items = localStorage.getItem('bookmarks_items')
      if (!this.id) {
        this.id = this.generateFavoritesUid()
        this.favorite_items = []
        localStorage.setItem('bookmarks_id', this.id)
        localStorage.setItem('bookmarks_items', JSON.stringify(this.favorite_items))
      } else {
        if (!this.favorite_items) {
          this.favorite_items = []
        } else {
          this.favorite_items = JSON.parse(this.favorite_items)
        }
      }
    }
    $.mlmi.favorites = this
    this.buttons()
    this.page()
  },
}

$.fn.FavoriteButton = function() {
  let self = this

  if (self.data('favorite-button')) {
    return self.data('favorite-button');
  }

  self.pressed = self.attr('aria-pressed') === 'true'
  self.uid = self.data('content-uid')

  self.add = function() {
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'add',
        'list_uid': $.mlmi.favorites.id,
        'content_uid': self.uid,
      },
      success: function(response) {
        $.mlmi.favorites.add(self.uid, response)
      },
      error: function(error) {
        self.toggle_off()
      },
    })
  }

  self.remove = function() {
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'remove',
        'list_uid': $.mlmi.favorites.id,
        'content_uid': self.uid,
      },
      success: function(response) {
        $.mlmi.favorites.remove(self.uid)
      },
      error: function(error) {
        self.toggle_on()
      },
    })
  }

  self.toggle_on = function() {
    self.pressed = true
    self.attr('aria-pressed', 'true')
  }

  self.toggle_off = function() {
    self.pressed = false
    self.attr('aria-pressed', 'false')
  }

  self.clicked = function(e) {
    if ($('html').hasClass('--logged-in')) {
      e.preventDefault()
      e.stopPropagation()

      if (self.pressed) {
        self.toggle_off()
        self.remove()
        $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_off()
        $('body').find('.btn-bookmark[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_off()
      } else {
        self.toggle_on()
        self.add()
        $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_on()
        $('body').find('.btn-bookmark[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_on()
      }
    }
    return true
  }

  return function() {
    self.on('click', self.clicked)
    if (!self.pressed) {
      self.toggle_off()
    }
    self.data('favorite-button', self)
    return self
  }()
}

$.fn.FavoritesPage = function() {
  let self = this

  return function() {
    /* Load items */
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_page',
        'language': 'en_us',
        'items': $.mlmi.favorites.favorite_items,
        'list': 0,
      },
      success: function(response) {
        response = $('<div>').append(response)
        let favoritesCount = 0

        /* Blog posts */
        response.find('.card-blog-post').each(function() {
          let blogPostCard = $(this).removeClass('fade-in'),
          gridItem = $('<div>').addClass('grid__item').append(blogPostCard)
          $('.favorites-grid .grid').append(gridItem)
          favoritesCount++
        })

        /* Show interface */
        if (!favoritesCount) {
          $('.favorites-grid').hide()
          $('.no-favorites').show()
        }

        /* Favorite buttons */
        favorites.buttons(self)
      },
      error: function(error) {
        console.log('Error', error)
      },
    })
    return self
  }()
}

export default favorites
